import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { selectFeaturePermissions } from "store/global/authPermission/selector";
import { PermissionFeature } from "store/global/authPermission/types";
import BreadCrumb from "app/components/BreadCrumb";

import WorkOrderStatusSummary from "./components/WorkOrderStatusSummary";
import VehicleInYard from "./components/VehicleInYard";
import ScheduleExceptions from "./components/ScheduleExceptions";
import EngineeringAlerts from "./components/EngineeringAlerts";
import { reducer, sliceKey } from "./redux/slice";
import { homeSaga } from "./redux/saga";
import { useStyles } from "./styles";

const Home = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: homeSaga,
  });

  const featurePermissions = useSelector(selectFeaturePermissions);
  const { hasNoAccess } = featurePermissions[PermissionFeature.DASHBOARD];

  return (
    <Box className={classes.container}>
        {hasNoAccess ? (
          <Box className={classes.noPermissionRoot}>
            <Typography variant="h5">{t("COMMON.NO_PERMISSION")}</Typography>
          </Box>
        ) : (
          <Box className={classes.scrollContent}>
            <Box className={classes.pageContent}>
              <BreadCrumb title={t("SIDEBAR.HOME")} iconPosition="end" />

              <Box className={classes.pageBody}>
                <WorkOrderStatusSummary />
                <Box className={classes.bottomGrid}>
                  <EngineeringAlerts />
                  <ScheduleExceptions />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
    </Box>
  );
};

export default Home;